module.exports = __webpack_public_path__ + "img/2012-08-18 09.13.39.b10df9f6.jpg";